module.exports = __webpack_public_path__ + "static/media/15.98106aac.png";